var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AsiDialog',{attrs:{"open":_vm.open,"unwrapped":""},on:{"cancel":_vm.cancel}},[_c('VideoCard',{attrs:{"source":_vm.source,"stop-video":_vm.stopVideo,"autoplay":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }